import { FEEDBACK_HOME_FEED_ENDPOINT, sceneHomeFeed, sceneUnknown, type Scene } from './types';

/**
 * Returns the baseline feedback scene used during root resets before tracked
 * routes authoritatively set their own scene values.
 */
export function deriveScene(pathname: string, isLoggedIn: boolean): Scene {
  if (pathname === '/') {
    return sceneHomeFeed(
      isLoggedIn ? FEEDBACK_HOME_FEED_ENDPOINT.UNIFIED : FEEDBACK_HOME_FEED_ENDPOINT.PUBLIC
    );
  }

  return sceneUnknown();
}
